module.exports = __webpack_public_path__ + "img/choose-plan.fc8b729a.svg";